/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const GET_CURRENT_DISPLAY_OBJ_CURRENT =
  'GET_CURRENT_DISPLAY_OBJ_CURRENT';
export const GET_CURRENT_DISPLAY_DETAIL_OBJ_CURRENT =
  'GET_CURRENT_DISPLAY_DETAIL_OBJ_CURRENT';
export const GET_PLAN_TYPE_DATA_CURRENT = 'GET_PLAN_TYPE_DATA_CURRENT';
export const GET_REBATE_PROGRAM_CURRENT = 'GET_REBATE_PROGRAM_CURRENT';
export const GET_ERROR_MSG_CURRENT = 'GET_ERROR_MSG_CURRENT';
export const GET_FROM_CURRENT = 'GET_FROM_CURRENT';
export const SELECT_OPTION = 'SELECT_OPTION';
export const GET_REBATE_PROGRAM_NAME_CURRENT =
  'GET_REBATE_PROGRAM_NAME_CURRENT';
export const GET_INVOICE_COMPARISON = 'GET_INVOICE_COMPARISON';
export const SET_REFRESH_DATA_CURRENT = 'SET_REFRESH_DATA_CURRENT';
export const REFRESH_DATA_CURRENT_DISPLAY = 'REFRESH_DATA_CURRENT_DISPLAY';
export const SET_DISPLAY_OBJ_CURRENT = 'SET_DISPLAY_OBJ_CURRENT';
